import React, { Component } from 'react';
import { ProgramStyle } from './platformComp';
import request from 'utils/request';
import $ from 'jquery';
import { Select, message, Upload, Pagination, Button } from 'antd';
import { LoadingOutlined, PlusOutlined, UploadOutlined, CustomerServiceOutlined } from '@ant-design/icons';
import { getCookie, baiduStatistics, imageUrl } from 'utils';
import { global } from 'config';

const { Option } = Select;

export default class Program extends Component {
    constructor(props) {
        super(props);

        this.state = {
            token: JSON.parse(getCookie('token')),
            status: 2,
            sale_status: -1,
            mask: false,
            title: '',
            introduction: '',
            firstadd: false,
            uploadFlag: false,
            loadFlag: false,
            index_album: 0,
            audioPaused: true,
            total: 1,
            per_page: 20,
            aname: '',
            wait: 1500, // 节流时间，
            is_request: false, // 请求接口开关
            previous: 0, // 上次的执行时间
        }
    }

    componentDidMount() {
        baiduStatistics();
        this.requestList();

        let audio = this.refs.audio;
        let _this = this;

        //开始播放：
        audio.onplay = function () {
            _this.setState({
                audioPaused: false
            })
        }

        //暂停播放：
        audio.onpause = function () {
            _this.setState({
                audioPaused: true
            })
        }
    }


    // 点击播放MP3
    play = () => {
        let audio = this.refs.audio;

        if (audio.paused) {
            // console.log('play');
            audio.play();
        } else {
            // console.log('pause');
            audio.pause();
        }
    }

    // 请求接口
    requestList = () => {
        const { token } = this.state;

        // 获取所有专辑
        request({
            url: 'huhuapi/Anchor/cateListManager',
            data: {
                os: 'pc',
                sign: token.sign,
                page: 1,
                _paginate: 0,
            }
        }).then(res => {
            // console.log(res.data);
            if (res.data.status) {

                this.requestPro([]);

                this.setState({
                    list: res.data.data.data,
                    dlength: res.data.data.data.length,
                });
            } else {
                message.error(res.data.errorStr);
            }
        }).catch(err => console.log(err));


    }

    skipPage = val => {
        // console.log(val);

        this.requestPro([null, val]);
    }

    // 刷新节目列表
    requestPro = ([val, page]) => {
        const { token, status, sale_status, cate_id, index_album } = this.state;

        if (index_album === 0) {
            if (sale_status === -1) {
                if (status === 2) {
                    request({
                        url: "huhuapi/Anchor/storyListManager",
                        data: {
                            os: 'pc',
                            sign: token.sign,
                            page: page ? page : 1,
                        }
                    }).then(res => {
                        // console.log(res.data.data.data);
                        if (res.data.status) {
                            this.setState({
                                program: res.data.data.data,
                                total: res.data.data.total === 0 ? 1 : res.data.data.total,
                                per_page: res.data.data.per_page,
                            });
                        } else {
                            message.error(res.data.errorStr);
                        }
                    }).catch(err => console.log(err));
                } else {
                    request({
                        url: "huhuapi/Anchor/storyListManager",
                        data: {
                            os: 'pc',
                            sign: token.sign,
                            page: page ? page : 1,
                            status,
                        }
                    }).then(res => {
                        // console.log(res.data.data.data);
                        if (res.data.status) {
                            this.setState({
                                program: res.data.data.data,
                                total: res.data.data.total === 0 ? 1 : res.data.data.total,
                                per_page: res.data.data.per_page,
                            });
                        } else {
                            message.error(res.data.errorStr);
                        }
                    }).catch(err => console.log(err));
                }
            } else {
                if (status === 2) {
                    request({
                        url: "huhuapi/Anchor/storyListManager",
                        data: {
                            os: 'pc',
                            sign: token.sign,
                            page: page ? page : 1,
                            sale_status
                        }
                    }).then(res => {
                        // console.log(res.data.data.data);
                        if (res.data.status) {
                            this.setState({
                                program: res.data.data.data,
                                total: res.data.data.total === 0 ? 1 : res.data.data.total,
                                per_page: res.data.data.per_page,
                            });
                        } else {
                            message.error(res.data.errorStr);
                        }
                    }).catch(err => console.log(err));
                } else {
                    request({
                        url: "huhuapi/Anchor/storyListManager",
                        data: {
                            os: 'pc',
                            sign: token.sign,
                            page: page ? page : 1,
                            status,
                            sale_status
                        }
                    }).then(res => {
                        // console.log(res.data.data.data);
                        if (res.data.status) {
                            this.setState({
                                program: res.data.data.data,
                                total: res.data.data.total === 0 ? 1 : res.data.data.total,
                                per_page: res.data.data.per_page,
                            });
                        } else {
                            message.error(res.data.errorStr);
                        }
                    }).catch(err => console.log(err));
                }
            }


        } else {
            if (sale_status === -1) {
                if (status === 2) {
                    request({
                        url: "huhuapi/Anchor/storyListManager",
                        data: {
                            os: 'pc',
                            sign: token.sign,
                            cate_id: val ? val : cate_id,
                            page: page ? page : 1,
                        }
                    }).then(res => {
                        // console.log(res.data.data.data);
                        if (res.data.status) {
                            this.setState({
                                program: res.data.data.data,
                                total: res.data.data.total === 0 ? 1 : res.data.data.total,
                                per_page: res.data.data.per_page,
                            });
                        } else {
                            message.error(res.data.errorStr);
                        }
                    }).catch(err => console.log(err));
                } else {
                    request({
                        url: "huhuapi/Anchor/storyListManager",
                        data: {
                            os: 'pc',
                            sign: token.sign,
                            cate_id: val ? val : cate_id,
                            page: page ? page : 1,
                            status,
                        }
                    }).then(res => {
                        // console.log(res.data.data.data);
                        if (res.data.status) {
                            this.setState({
                                program: res.data.data.data,
                                total: res.data.data.total === 0 ? 1 : res.data.data.total,
                                per_page: res.data.data.per_page,
                            });
                        } else {
                            message.error(res.data.errorStr);
                        }
                    }).catch(err => console.log(err));
                }
            } else {
                if (status === 2) {
                    request({
                        url: "huhuapi/Anchor/storyListManager",
                        data: {
                            os: 'pc',
                            sign: token.sign,
                            cate_id: val ? val : cate_id,
                            page: page ? page : 1,
                            sale_status
                        }
                    }).then(res => {
                        // console.log(res.data.data.data);
                        if (res.data.status) {
                            this.setState({
                                program: res.data.data.data,
                                total: res.data.data.total === 0 ? 1 : res.data.data.total,
                                per_page: res.data.data.per_page,
                            });
                        } else {
                            message.error(res.data.errorStr);
                        }
                    }).catch(err => console.log(err));
                } else {
                    request({
                        url: "huhuapi/Anchor/storyListManager",
                        data: {
                            os: 'pc',
                            sign: token.sign,
                            cate_id: val ? val : cate_id,
                            page: page ? page : 1,
                            status,
                            sale_status
                        }
                    }).then(res => {
                        // console.log(res.data.data.data);
                        if (res.data.status) {
                            this.setState({
                                program: res.data.data.data,
                                total: res.data.data.total === 0 ? 1 : res.data.data.total,
                                per_page: res.data.data.per_page,
                            });
                        } else {
                            message.error(res.data.errorStr);
                        }
                    }).catch(err => console.log(err));
                }
            }
        }

    }

    // 渲染专辑
    renderAlbum = () => {
        const { list } = this.state;

        return list && list.map((item, index) => <Option key={item.id} value={index + 1}>{item.name}</Option>);
    }

    // 处理时间
    dur = (str) => {
        if (typeof str == 'string') {
            if (str.length === 8) {
                return str.slice(3);
            }

            return str;
        }
    }

    // 渲染节目列表
    renderList = () => {
        const { program } = this.state;

        let status = {
            '0': '审核中',
            '1': '审核成功',
            '-2': '审核失败'
        }

        let sale_status = {
            '0': '下架',
            '1': '上架 ',
        }

        let colors = {
            '0': '#28B6FF',
            '-2': '#FF4D4D',
            '1': '#44D7B6'
        }

        let arr;
        if (program) {
            if (program.length < 6 && program.length > 0) {
                arr = [].concat(program);
                for (let i = 0; i < 6 - program.length; i++) {
                    arr.push({});
                }

                return arr.map((item, index) => <div key={index} className="program-item" style={{ background: index % 2 === 1 ? 'rgba(248,249,251,1)' : 'rgba(252,253,255,1)', borderTop: '.5px solid #dcdcdc' }}>
                    <div className="item" style={{ width: '15%' }}><div style={{ width: '80%', textAlign: 'center' }}>{item.title}</div></div>
                    <div className="item" style={{ width: '13%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc' }}>
                        {item.image_show && <img style={{ width: '80px', height: '80px', borderRadius: '14px' }} alt="" src={imageUrl(item.image_show)} />}
                    </div>
                    <div className="item" style={{ width: '14%' }}>{this.dur(item.duration)}</div>
                    <div className="item" style={{ width: '12%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc' }}>{item.view_num}</div>
                    <div className="item" style={{ width: '15%', }}><div style={{ width: '80%', textAlign: 'center' }}>{item.update_time ? item.update_time : item.create_time}</div></div>
                    <div className="item" style={{ width: '11%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc' }}>{sale_status[item.sale_status]}</div>
                    <div className="item" style={{ width: '11%', color: colors[item.status] }}>{status[item.status]}</div>
                    {item.id ? <div className="item eeee" style={{ width: '9%', cursor: 'pointer', borderLeft: '.5px solid #dcdcdc', }} onClick={() => this.aduit(item, index)}>编辑</div> : <div className="item" style={{ width: '9%', cursor: 'pointer', borderLeft: '.5px solid #dcdcdc', }}></div>}
                </div>);
            } else {
                arr = program;
                return arr.map((item, index) => <div key={index} className="program-item" style={{ background: index % 2 === 1 ? 'rgba(248,249,251,1)' : 'rgba(252,253,255,1)', borderTop: '.5px solid #dcdcdc' }}>
                    <div className="item" style={{ width: '15%' }}><div style={{ width: '80%', textAlign: 'center' }}>{item.title}</div></div>
                    <div className="item" style={{ width: '13%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc' }}>
                        {item.image_show && <img style={{ width: '80px', height: '80px', borderRadius: '14px' }} alt="" src={imageUrl(item.image_show)} />}
                    </div>
                    <div className="item" style={{ width: '14%' }}>{this.dur(item.duration)}</div>
                    <div className="item" style={{ width: '12%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc' }}>{item.view_num}</div>
                    <div className="item" style={{ width: '15%', }}><div style={{ width: '80%', textAlign: 'center' }}>{item.update_time ? item.update_time : item.create_time}</div></div>
                    <div className="item" style={{ width: '11%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc' }}>{sale_status[item.sale_status]}</div>
                    <div className="item" style={{ width: '11%', color: colors[item.status] }}>{status[item.status]}</div>
                    <div className="item eeee" style={{ width: '9%', cursor: 'pointer', borderLeft: '.5px solid #dcdcdc', }} onClick={() => this.aduit(item, index)}>编辑</div>
                </div>);
            }
        }
    }

    // 受控组件
    write = key => e => {
        this.setState({
            [key]: e.target.value,
        });
    }

    // 筛选
    handleChange = value => {
        // console.log(value);
        const { mask } = this.state;

        switch (value) {
            case 'puton':
                this.setState({
                    sale_status: 1
                }, () => {
                    if (!mask) this.requestPro([]);
                });
                break;
            case 'pullof':
                this.setState({
                    sale_status: 0
                }, () => {
                    if (!mask) this.requestPro([]);
                });
                break;
            case 'all':
                this.setState({
                    sale_status: -1
                }, () => {
                    this.requestPro([]);
                });
                break;
            case 'progress':
                this.setState({
                    status: 0
                }, () => {
                    this.requestPro([]);
                });
                break;
            case 'failed':
                this.setState({
                    status: -2
                }, () => {
                    this.requestPro([]);
                });
                break;
            case 'successed':
                this.setState({
                    status: 1
                }, () => {
                    this.requestPro([]);
                });
                break;
            case 'all2':
                this.setState({
                    status: 2
                }, () => {
                    this.requestPro([]);
                });
                break;
            default:
                break;
        }
    }

    handleChange1 = value => {
        // console.log(value);
        switch (value) {
            case 'puton':
                this.setState({
                    sale_status1: 1
                });
                break;
            case 'pullof':
                this.setState({
                    sale_status1: 0
                });
                break;

            default:
                break;
        }
    }

    // 切换专辑
    albumChange = value => {
        // console.log(value);
        const { list } = this.state;

        if (value === 0) {
            this.setState({
                cate_id: null,
                index_album: value
            }, () => {
                this.requestPro([]);
            });
            return;
        }
        this.setState({
            cate_id: list[value - 1].id,
            index_album: value
        }, () => {
            this.requestPro([]);
        });
    }

    // 切换专辑
    albumChange1 = value => {
        // console.log(value);
        const { list } = this.state;

        this.setState({
            cate_id1: list[value - 1].id
        });
    }

    // 
    changeMask = () => {
        const { mask } = this.state;
        let audio = this.refs.audio;
        audio.pause();

        this.setState({
            mask: !mask,
            audioPaused: true
        });

        if (mask) {
            $('body').removeClass('no-scroll-mask');
        } else {
            $('body').addClass('no-scroll-mask');
        }
    }


    changefirstadd = () => {
        const { firstadd } = this.state;

        this.setState({
            firstadd: !firstadd
        });
    }


    // 上传音频
    handeSend = (e) => {
        let audio = this.refs.audio;
        const { token } = this.state;
        let _this = this;

        let file = document.querySelector('#audio_file').files[0];

        if (file) {
            message.info('文件正在上传，请稍候');

            let formdata = new FormData();
            formdata.append('file', file);
            formdata.append('os', 'pc');
            formdata.append('name', file.name);
            formdata.append('size', file.size);
            formdata.append('sign', token.sign);


            $.ajax({
                type: "POST",
                // url: `${global.domain}huhuapi/Fileupload/upload?name=${file.name}&size=${file.size}&os=pc&sign=${token.sign}`,
                url: `${global.domain}huhuapi/Fileupload/upload`,
                // url: `${global.domain}huhuapi/files/upload_anchor`,
                data: formdata,
                contentType: false,
                processData: false,
                success: function (data) {
                    // console.log(data);

                    if (data.status) {
                        message.success('上传成功');
                        _this.setState({
                            loadFlag: false,
                            uploadFlag: true,
                            size: file.size,
                            duration: data.data.duration,
                            filename: data.data.filename,
                            aname: data.data.name,
                        }, () => {
                            // console.log($('.upaudio-done').width() + 36);
                            $('#audio_file').css({
                                width: $('.upaudio-done').width() + 36 + 'px'
                            });
                        });
                        audio.src = data.data.filename;
                        audio.pause();
                    } else {
                        message.error(data.errorStr);
                    }

                }
            });
        }
    }


    handeSend1 = info => {
        let fileList = [...info.fileList];
        let audio = this.refs.audio;

        // 限制上传文件数量
        fileList = fileList.slice(-1);
        // console.log(fileList);

        fileList = fileList.map(file => {
            if (file.response) {
                // console.log(file.response);
                if (file.response.status) {
                    // file.url = file.response.data.filename;

                    audio.src = file.response.data.filename;
                    audio.pause();

                    this.setState({
                        size: file.response.data.size,
                        duration: file.response.data.duration,
                        filename: file.response.data.filename,
                        aname: file.response.data.name,
                    });
                } else {
                    message.error(file.response.errorStr);
                }
            }
            return file;
        });

        this.setState({ fileList });
    }

    // 限制上传音频参数（大小，格式）
    beforeUpload = file => {
        // console.log(file);
        return file;
    }

    // 上传事件
    sendImage = info => {
        // console.log(info);
        if (info.file.status === 'uploading') {
            this.setState({ loading: true });
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.

            if (info.file.response) {
                if (info.file.response.status) {
                    this.setState({
                        imgUrl: imageUrl(info.file.response.msg.file_url),
                        image: info.file.response.msg.save_path,
                        loading: false
                    });
                    message.success('上传成功');
                } else {
                    message.error(info.file.response.msg);
                }
            }
        }
    };

    openMask = () => {
        const { dlength, cate_id, list, index_album } = this.state;
        let audio = this.refs.audio;
        audio.pause();

        if (!dlength) {
            this.setState({
                sale_status1: 1,
                mask: false,
                title: '',
                introduction: '',
                firstadd: true,
                uploadFlag: false,
                size: '',
                duration: '',
                filename: '',
                text: '创建节目',
                loadFlag: false,
                imgUrl: '',
                image: '',
                audioPaused: true,
                aname: '',
                aduitId: null
            });
            $('body').removeClass('no-scroll-mask');
            return;
        }
        this.setState({
            sale_status1: 1,
            mask: true,
            title: '',
            introduction: '',
            firstadd: false,
            uploadFlag: false,
            size: '',
            duration: '',
            filename: '',
            cate_id1: cate_id ? cate_id : list[0].id,
            text: '创建节目',
            loadFlag: false,
            loading: false,
            imgUrl: '',
            image: '',
            audioPaused: true,
            aname: '',
            index_album1: index_album,
            aduitId: null,
            fileList: null,
            showUploadList: {
                showRemoveIcon: true,
            }
        });
        $('body').addClass('no-scroll-mask');
    }

    // 编辑
    aduit = (item, index) => {
        const { list, } = this.state;
        let audio = this.refs.audio;
        let i;
        list.map((val, ind) => {
            if (val.id === item.cate_id) {
                i = ind;
            }
            return i;
        })

        audio.src = item.filename;
        audio.pause();

        this.setState({
            loading: false,
            introduction: item.introduction,
            image: item.image,
            imgUrl: imageUrl(item.image),
            title: item.title,
            sale_status1: item.sale_status,
            mask: true,
            aduitId: item.id,
            uploadFlag: true,
            size: item.size,
            duration: item.duration,
            filename: item.filename,
            text: '编辑节目',
            cate_id1: item.cate_id,
            aname: '',
            index_album1: i + 1,
            fileList: [{
                name: item.title,
                size: item.size,
                uid: item.id,
                status: 'done'
            }],
            showUploadList: {
                showRemoveIcon: false,
            }
        }, () => {
            // console.log($('.upaudio-done').width() + 36);
            $('#audio_file').css({
                width: $('.upaudio-done').width() + 36 + 'px'
            });
        });
        $('body').addClass('no-scroll-mask');
    }

    // 创建编辑节目
    createProgram = () => {
        const { introduction, title, fileList, sale_status1, image, wait, is_request, previous, token, aduitId, cate_id1, filename, size, duration } = this.state;

        let now = Date.now(); //获得当前时间戳
        if (now - previous > wait) {
            if (is_request) {
                return;
            }

            if (fileList && fileList.length && filename && title) {
                if (aduitId) {
                    this.setState({
                        is_request: true
                    });

                    this.changeMask();

                    request({
                        url: 'huhuapi/Anchor/storyEditManager',
                        data: {
                            os: 'pc',
                            sign: token.sign,
                            introduction,
                            title,
                            sale_status: sale_status1,
                            filename,
                            image,
                            cate_id: cate_id1,
                            id: aduitId,
                            size,
                            duration,
                        }
                    }).then(res => {
                        // console.log(res.data);
                        if (res.data.status) {
                            this.setState({
                                previous: now,
                                is_request: false
                            });
                            this.requestPro([]);
                            message.success(res.data.data.msg);
                        } else {
                            this.setState({
                                previous: now,
                                is_request: false
                            });
                            message.error(res.data.errorStr);
                        }

                    }).catch(err => {
                        this.setState({
                            previous: now,
                            is_request: false
                        });
                        console.log(err);
                    });
                } else {
                    this.setState({
                        is_request: true
                    });

                    this.changeMask();

                    request({
                        url: 'huhuapi/Anchor/storyAddManager',
                        data: {
                            os: 'pc',
                            sign: token.sign,
                            introduction,
                            title,
                            sale_status: sale_status1,
                            filename,
                            image,
                            cate_id: cate_id1,
                            size,
                            duration,
                        }
                    }).then(res => {
                        // console.log(res.data);
                        if (res.data.status) {
                            this.setState({
                                previous: now,
                                is_request: false
                            });
                            this.requestPro([]);
                            message.success(res.data.data.msg);
                        } else {
                            this.setState({
                                previous: now,
                                is_request: false
                            });
                            message.error(res.data.errorStr);
                        }

                    }).catch(err => {
                        this.setState({
                            previous: now,
                            is_request: false
                        });
                        console.log(err);
                    });
                }

            } else {
                this.setState({
                    previous: now,
                    is_request: false
                });

                message.error('请完善节目信息');
            }
        }
    }

    // 自定义icon
    handleLoad = (file, listType) => {
        // console.log(file, listType);

        if (file.status === 'done') {
            return (<CustomerServiceOutlined style={{ color: "#1890ff" }} />);
        } else {
            return (<LoadingOutlined />);
        }
    }

    render() {
        const { mask, title, token, showUploadList, fileList, text, introduction, filename, sale_status1, program, index_album1, firstadd, size, duration, imgUrl, audioPaused, total, per_page, } = this.state;
        const uploadButton = (
            <div>
                {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
                <div className="ant-upload-text">选择图片</div>
            </div>
        );
        const { push } = this.props.history;

        function forM(str) {
            if (typeof str == 'string' && str.indexOf('M') !== -1) {
                return str;
            }

            return (str / 1024 / 1024).toFixed(2) + 'M';
        }

        const props = {
            name: 'file',
            accept: "audio/*",
            // listType: 'picture-card',
            action: `${global.domain}huhuapi/Fileupload/upload`,
            data: file => ({ os: 'pc', name: file.name, size: file.size, sign: token.sign }),
            onChange: this.handeSend1,
            beforeUpload: this.beforeUpload,
            progress: {
                strokeColor: {
                    '0%': '#108ee9',
                    '100%': '#87d068',
                },
                strokeWidth: 3,
                format: percent => `${parseFloat(percent.toFixed(2))}%`,
            },
            onRemove: () => {
                let audio = this.refs.audio;
                audio.pause();

                this.setState({
                    filename: ''
                });
            },
            fileList: fileList,
            showUploadList: showUploadList,
            iconRender: this.handleLoad
        };

        return (<ProgramStyle>
            <div className='program-kfpt'>
                <header className="program-header">
                    <div className="header-line">
                        <div className="header-title">专辑筛选</div>
                        <Select defaultValue={0} style={{ width: 120 }} onChange={this.albumChange}>
                            <Option value={0}>全部</Option>
                            {this.renderAlbum()}
                        </Select>
                    </div>
                    <div className="header-line">
                        <div className="header-title">节目发布状态</div>
                        <Select defaultValue="all" style={{ width: 100 }} onChange={this.handleChange}>
                            <Option value="all">全部</Option>
                            <Option value="puton">上架</Option>
                            <Option value="pullof">下架</Option>
                        </Select>
                        <div className="header-title">节目审核状态</div>
                        <Select defaultValue="all2" style={{ width: 120 }} onChange={this.handleChange}>
                            <Option value="all2">全部</Option>
                            <Option value="progress">审核中</Option>
                            <Option value="failed">审核失败</Option>
                            <Option value="successed">审核成功</Option>
                        </Select>
                        <div className="create-program" onClick={this.openMask}>添加节目</div></div>
                </header>

                <div className="program-main">
                    <div className="main-tabs">
                        <div style={{ width: '15%', fontWeight: 'bold' }}>节目名字</div>
                        <div style={{ width: '13%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc', fontWeight: 'bold' }}>封面</div>
                        <div style={{ width: '14%', fontWeight: 'bold' }}>播放时间</div>
                        <div style={{ width: '12%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc', fontWeight: 'bold' }}>播放量</div>
                        <div style={{ width: '15%', fontWeight: 'bold' }}>发布时间</div>
                        <div style={{ width: '11%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc', fontWeight: 'bold' }}>发布状态</div>
                        <div style={{ width: '11%', fontWeight: 'bold' }}>审核状态</div>
                        <div style={{ width: '9%', borderLeft: '.5px solid #dcdcdc', fontWeight: 'bold' }}>操作</div>
                    </div>
                    {program && program.length !== 0 ? <div className="program-list">
                        {this.renderList()}
                    </div> : <div className="program-empty" style={{ borderTop: '.5px solid #dcdcdc' }}>
                            <img src={require('images/platform/empty.png')} className="empty" alt="" />
                            <div className="text">暂时没有节目</div>
                        </div>}
                </div>
                <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                    <Pagination defaultCurrent={1} total={total} pageSize={per_page} onChange={this.skipPage} showSizeChanger={false} />
                </div>
            </div>

            {mask && <div className="mask">
                <div className="mask-con">
                    <div className="mask-title">{text}</div>
                    <div className="mask-ablum">
                        <div className="mask-word">专辑名字</div>
                        <Select defaultValue={index_album1 ? index_album1 : 1} onChange={this.albumChange1}>
                            {this.renderAlbum()}
                        </Select>
                        <span>*</span>
                    </div>
                    <div className="mask-name">
                        <div className="mask-word">节目名字</div>
                        <input className="mask-pro" placeholder="最多填写14个字" maxLength="14" value={title} onChange={(e) => this.write('title')(e)} />
                        <span>*</span>
                    </div>
                    <div className="mask-intro">
                        <div className="mask-word">节目简介</div>
                        <textarea className="mask-area" maxLength="50" placeholder="最多填写50个字" value={introduction} onChange={(e) => this.write('introduction')(e)}></textarea>
                    </div>
                    {/* <div className="mask-audio">
                        <div className="mask-word">上传音频</div>
                        <input type='file' id="audio_file" onChange={this.handeSend} accept="audio/*" />
                        {!uploadFlag ? <Fragment> <div className="upaudio">{loadFlag ? <LoadingOutlined /> : ''}上传</div><span className="iii">*</span></Fragment> :
                            <Fragment><div className="upaudio-done">{aname ? `名称：${aname}` : ''}&nbsp; 时间：{duration}&nbsp; 大小：{(size / 1024 / 1024).toFixed(1)}M</div><img style={{ width: '20px', height: '20px', marginLeft: '10px', cursor: 'pointer' }} src={audioPaused ? require('images/platform/play.png') : require('images/platform/pause.png')} onClick={this.play} alt="" /></Fragment>}

                    </div> */}
                    <div className="mask-audio">
                        <div className="mask-word">上传音频</div>
                        <Upload
                            {...props}
                        >
                            <Button>
                                <UploadOutlined /> 选择文件
                            </Button>
                        </Upload>

                        {filename ? <img className="audio-control" src={audioPaused ? require('images/platform/play.png') : require('images/platform/pause.png')} onClick={this.play} alt="" /> : <span className="iii">*</span>}
                    </div>
                    {filename && fileList.length ? <div className="mask-detail"><span style={{ marginRight: '20px' }}>时长：{this.dur(duration)}</span>  <span>大小：{forM(size)}</span></div> : ''}

                    <div className="limit">请上传30M以内的文件，最高支持320kbps码率，目前仅支持MP3格式的音频文件。</div>
                    <div className="mask-cover">
                        <div className="mask-word">节目封面</div>
                        <Upload
                            name="file"
                            listType="picture-card"
                            className="avatar-uploader"
                            showUploadList={false}
                            action={global.domain + "huhuapi/files/upload_image"}
                            onChange={this.sendImage}
                        >
                            {imgUrl ? <img src={imgUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                        </Upload>
                    </div>
                    <div className="mask-tip">请上传1M以内的文件，支持JPG、PNG格式。建议上传尺寸为500px*500px的图片。</div>
                    <div className="mask-release">
                        <div className="mask-word">状态</div>
                        <Select defaultValue={sale_status1 === 1 ? "puton" : "pullof"} style={{ width: 100 }} onChange={this.handleChange1}>
                            <Option value="puton">上架</Option>
                            <Option value="pullof">下架</Option>
                        </Select>
                    </div>
                    <div className="status-tip">*审核时间约2小时</div>
                    <div className="mask-btns">
                        <div className="btn1" onClick={this.createProgram}>确定</div>
                        <div className="btn2" onClick={this.changeMask}>取消</div>
                    </div>
                </div>
            </div>}

            {
                firstadd && <div className="firstadd">
                    <div className="firstadd-con">
                        <img alt="" src={require('images/platform/mask.png')} className="firstadd-img" />
                        <div className="firstadd-title">提示</div>
                        <div className="firstadd-text">需要先创建专辑才能添加节目哦</div>
                        <div className="firstadd-btns">
                            <div className="firstadd-btn1" onClick={this.changefirstadd}>取消</div>
                            <div className="firstadd-btn2" onClick={() => { this.changefirstadd(); push('/platform/album') }}>去创建</div>
                        </div>
                    </div>
                </div>
            }

            <audio ref="audio" src='' style={{ display: 'none' }}>
                Your browser does not support the audio element.
            </audio>
        </ProgramStyle >);
    }
}